export const renderAnalyzeData = (data: any, id: string) => {
  if (!data || !id) return null;
  const content = data.recommendations.find((rec) => rec.variant === id);
  return content ? content.recommendation : null;
};
